const EmailInfo = ({ className }: { className?: string }) => {
  return (
    <a className={className} href="mailto:info@insularis.nl">
      info@insularis.nl
    </a>
  );
};

export default EmailInfo;
